angular.module('impactx.userdialog').controller('ControlDialogUserCtrl', ['$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'TranslationService',
    'ControlRelationService',
    'ToolbarService',
    'PartialDialogsService',
    ControlDialogUserCtrl]);

function ControlDialogUserCtrl($scope, dataGen, $routeParams, BackService, ToastService, TranslationService,
                               ControlRelationService, ToolbarService, PartialDialogsService) {
    var ctrl = this;

    $scope.userId = $routeParams.id;
    dataGen.getData($scope, {id: $routeParams.id}, "/user/control/view").then(function (data) {
        if (data.data.cttRelation) {
            $scope.ctt = {};
            ControlRelationService.setControlDataToScope($scope.ctt, data.data.cttRelation);
        }
        if (data.data.ctuRelation) {
            $scope.ctu = {};
            ControlRelationService.setControlDataToScope($scope.ctu, data.data.ctuRelation);
        }
        if (data.data.prjRelation) {
            $scope.prj = {};
            ControlRelationService.setControlDataToScope($scope.prj, data.data.prjRelation);
        }
        if (data.data.crdRelation) {
            $scope.crd = {};
            ControlRelationService.setControlDataToScope($scope.crd, data.data.crdRelation);
        }
        if (data.data.ctrlARelation) {
            $scope.ctrlA = {};
            ControlRelationService.setControlDataToScope($scope.ctrlA, data.data.ctrlARelation);
        }
        if (data.data.ctrlBRelation) {
            $scope.ctrlB = {};
            ControlRelationService.setControlDataToScope($scope.ctrlB, data.data.ctrlBRelation);
        }
        if (data.data.ctrlCRelation) {
            $scope.ctrlC = {};
            ControlRelationService.setControlDataToScope($scope.ctrlC, data.data.ctrlCRelation);
        }
        if (data.data.ctrlDRelation) {
            $scope.ctrlD = {};
            ControlRelationService.setControlDataToScope($scope.ctrlD, data.data.ctrlDRelation);
        }
        if (data.data.pspRelation) {
            $scope.psp = {};
            ControlRelationService.setControlDataToScope($scope.psp, data.data.pspRelation);
        }
        if (data.data.actRelation) {
            $scope.act = {};
            ControlRelationService.setControlDataToScope($scope.act, data.data.actRelation);
        }
        if (data.data.netRelation) {
            $scope.net = {};
            ControlRelationService.setControlDataToScope($scope.net, data.data.netRelation);
        }
        if (data.data.asnRelation) {
            $scope.asn = {};
            ControlRelationService.setControlDataToScope($scope.asn, data.data.asnRelation);
        }
        if (data.data.inoRelation) {
            $scope.ino = {};
            ControlRelationService.setControlDataToScope($scope.ino, data.data.inoRelation);
        }
        if (data.data.locRelation) {
            $scope.loc = {};
            ControlRelationService.setControlDataToScope($scope.loc, data.data.locRelation);
        }
        if (data.data.ekoRelation) {
            $scope.eko = {};
            ControlRelationService.setControlDataToScope($scope.eko, data.data.ekoRelation);
        }
        if (data.data.ekgRelation) {
            $scope.ekg = {};
            ControlRelationService.setControlDataToScope($scope.ekg, data.data.ekgRelation);
        }

        defineButtons();
    });


    ctrl.save = function ($event, showOthers) {
        var dataObj = {
            control: $scope.data
        };

        if ($scope.data.cttRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.cttRelation, $scope.ctt);
        }
        if ($scope.data.ctuRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ctuRelation, $scope.ctu);
        }
        if ($scope.data.prjRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.prjRelation, $scope.prj);
        }
        if ($scope.data.crdRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.crdRelation, $scope.crd);
        }
        if ($scope.data.ctrlARelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ctrlARelation, $scope.ctrlA);
        }
        if ($scope.data.ctrlBRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ctrlBRelation, $scope.ctrlB);
        }
        if ($scope.data.ctrlCRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ctrlCRelation, $scope.ctrlC);
        }
        if ($scope.data.ctrlDRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ctrlDRelation, $scope.ctrlD);
        }
        if ($scope.data.pspRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.pspRelation, $scope.psp);
        }
        if ($scope.data.actRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.actRelation, $scope.act);
        }
        if ($scope.data.netRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.netRelation, $scope.net);
        }
        if ($scope.data.asnRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.asnRelation, $scope.asn);
        }
        if ($scope.data.inoRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.inoRelation, $scope.ino);
        }
        if ($scope.data.locRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.locRelation, $scope.loc);
        }
        if ($scope.data.ekoRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ekoRelation, $scope.eko);
        }
        if ($scope.data.ekgRelation) {
            ControlRelationService.copyRelationDataToDTO(dataObj.control.ekgRelation, $scope.ekg);
        }

        return dataGen.postAsForm($scope, dataObj, "/user/control/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if(showOthers)
            {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, $scope.userId, 'usercontrol', undefined, true);
            }
            else
            {
                PartialDialogsService.addDialog(PartialDialogsService.TYPE.USER, $scope.userId, 'usercontrol');
                PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
            }
        });
    };

    ctrl.saveBackToList = function ($event) {
        return ctrl.save($event, false)
    };

    ctrl.saveOtherDialogs = function ($event) {
        return ctrl.save($event, true)
    };

    function valueFunction() {
        return $scope.data && $scope.data.userCard && $scope.data.userCard.maxNumberOfUsersReached
            && !$scope.data.userCard.canSaveWithMaxNumberOfUsersReached;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.saveBackToList,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: ctrl.saveOtherDialogs,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}